import { request } from "../request";


export type OutputGetSystemConfig = {
  /**
   * 客户端主域名
   */
  MAIN_WEB_HOST: string,
  /**
   * 资源HOST地址
   */
  RESOURCE_HOST: string,
  /**
   * 客服连接
   */
  CustomerAddress: string,
  /**
   * 系统名称
   */
  SystemName: string,
  /**
   * 系统LOGO
   */
  SystemLogo: string,
  /**
   * AI图标按钮
   */
  AiIconBtn: string,
  /**
   * 系统维护
   */
  SystemMaintenance: boolean,
  /**
   * 系统维护描述
   */
  SystemMaintenanceDesc: string,
  /**
   * USD 美元汇率
   */
  Usd: string
};


/**
 * 获取系统配置
 */
export function fetchGetSystemConfigAsync() {
  return request<OutputGetSystemConfig>({
    url: "/Global/GetSystemConfig",
    method: "get"
  });
}

type UploadResponse = {
  url: string,
  name: string,
  fileSize: number
};
/**
 * 获取关卡配置列表
 * @returns
 */
export function fetchUploadFile(files: File[] | File) {
  // const formData = new FormData();
  // if (Array.isArray(files)) {
  //   files.forEach(file => {
  //     formData.append('files', file);
  //   });
  // }
  // else {
  //   formData.append('files', files);
  // }

  return request<UploadResponse[]>({
    url: '/Global/UploadFile',
    method: "post",
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: {
      files: files
    }
  });
}

/**
 * 获取当前系统时间
 */
export async function fetchGetCurrentUtcTimestampAsync() {
  try {
    const resp = await request<{
      CurrentUtcTimestamp: number
    }>({
      url: "/Global/GetCurrentUtcTimestamp",
      method: "get"
    });
    if (resp.CheckIsOk(false)) {
      return resp.data?.CurrentUtcTimestamp ?? Date.now();
    }
    else {
      return Date.now();
    }
  }
  catch (ex) {
    return Date.now();
  }
}